module.exports = __webpack_public_path__ + "static/media/home.4773e269.svg";